var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-text-grey-600",attrs:{"title":_vm.address}},[(_vm.showIcon)?_c('fa',{staticClass:"tw-mr-1",attrs:{"icon":_vm.icons.mapMarker}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.address))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }